import React from 'react';

// mui
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';

export const renderOption = ({ value, label }) => (
  <MenuItem key={`${value}-${label}`} value={value}>
    {label}
  </MenuItem>
);

export const renderDivider = () => (
  <ListSubheader key="divider">
    <Divider />
  </ListSubheader>
);
